<template>
  <v-container grid-list-xl v-if="diklatAktif">
    <v-row wrap>
      <v-col cols="12">
        <m-card-list
          :title="`Daftar `+ diklatAktif.jenisdiklat.label_kelas"
          :add="isCan('kelas')&&diklatAktif.is_aktif"
          :unduh="isCan('kelas')&&unduhTS.includes(diklatAktif.jenisdiklat.id)"
          search
          id-key
          filter
          @refresh="load"
          :items="items"
          :footerLabel="diklatAktif.jenisdiklat.label_kelas"
          @search="
            search => {
              textSearch = search;
              pencarian();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          @unduh="unduh"
          footer
        >
          <template v-slot:filter>
            <FilterKelas @filter="filter" class="px-5" />
          </template>
          <template v-slot:items="{ item }">
            <v-container>
              <v-row class="mx-3" no-gutters>
                <v-col cols="3" sm="1" md="1" lg="1" align="center">
                  <v-avatar width="50" height="50" :size="45" color="secondary2">
                    <v-icon color="secondary">mdi-google-classroom</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="10">
                  <v-row>
                    <v-col class="py-0" cols="12" md="4" sm="4">
                      <router-link
                        class="primary--text ok title"
                        :to="{
                          name: 'kelas.detail',
                          params: { instansi_id: item.instansi_id, diklat_id: item.diklat_id, kelas_id: item.id }
                        }"
                        >{{ pVal(item, "nama") }}</router-link
                      >
                      <p v-if="item.bgp" class="caption my-0 py-0 purple--text align-left">
                        BGP/BBGP: {{ item.bgp.nama }}
                      </p>
                      <p class="caption">Zona Waktu: {{ item.zona_waktu }}</p>
                    </v-col>

                    <v-col class="py-0" cols="12" md="3" sm="3">
                      <p class="caption my-0 py-0 grey--text">Tanggal Pelaksanaan</p>
                      <span class="my-0 py-0 text-caption"
                        >{{ pVal(item, "tanggal_mulai") | toDT }} s/d {{ pVal(item, "tanggal_selesai") | toDT }}</span
                      >
                    </v-col>
                    <v-col class="py-0" cols="12" md="3" sm="3">
                      <p class="caption my-0 py-0 grey--text">Fasilitator</p>
                      <div v-for="f in cekFasil(item.fasilitator)" :key="f.index">
                        <span :class="f.name === 'Tidak tersedia' ? 'red--text' : 'black--text'">{{ f.name }}</span>
                        <p class="text-caption py-0 my-0">
                          {{ f.telp
                          }}<v-icon
                            v-if="f.telp !== null && f.telp !== ''"
                            class="ml-1"
                            color="green"
                            small
                            @click="toWA(f.telp)"
                            >mdi-whatsapp</v-icon
                          >
                        </p>
                      </div>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2" sm="2">
                      <p class="my-0 caption grey--text">Status</p>
                      <v-chip class="justify-center" label outlined :color="item.is_lengkap ? 'success' : 'warning'">{{
                        item.is_lengkap == 0 ? "Belum Sinkron" : "Sinkron"
                      }}</v-chip>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col lg="1" md="1" sm="1" cols="1">
                  <m-menu right class="clearfix" style="float:right" :items="more_menu" :object="item" />
                </v-col>
              </v-row>
            </v-container>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../kelas/components/Form.vue";
import FilterKelas from "@/filter/FilterKelas.vue";

export default {
  components: {
    ChangeDlg,
    FilterKelas
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      diklat: null,
      unduhTS: [141,149]
    };
  },
  computed: {
    more_menu() {
      return [
        // eslint-disable-next-line
        {
          title: "Detail",
          icon: "mdi-eye",
          color: "info",
          click: (i, o) =>
            // eslint-disable-next-line
            this.$router.push({
              name: "kelas.detail",
              params: {
                instansi_id: o.instansi_id,
                diklat_id: o.diklat_id,
                kelas_id: o.id
              }
            })
        },
        {
          title: "Tautan Materi",
          icon: "mdi-link",
          color: "success",
          click: (i, o) => this.course(o),
          check: (i, o) => o.created == 1 && this.diklatAktif.is_aktif
        },
        {
          title: "Sinkron "+this.diklatAktif.jenisdiklat.label_kelas,
          icon: "mdi-sync",
          color: "success",
          click: (i, o) => this.approve(o),
          check: (i, o) => o.is_lengkap == 0 &&this.diklatAktif.is_aktif
        },
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o),
          check: () => isCan("kelas") &&this.diklatAktif.is_aktif
        },
        {
          title: "Tautan LMS",
          icon: "mdi-link",
          color: "success",
          click: (i, o) => this.selfEnrol(o),
          check: () => isCan("self-enrol") && this.diklat && this.diklat.data.is_selfenrol === true &&this.diklatAktif.is_aktif
        }
      ];
    },
    diklatAktif() {
      return this.$store.getters["diklat/diklat_aktif"];
    },
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.loadDiklat();
    this.load();
  },
  methods: {
    loadDiklat() {
      this.$store
        .dispatch("diklat/detail", { instansi_id: this.instansi_id, diklat_id: this.$route.params.diklat_id })
        .then(res => {
          this.diklat = res;
        })
        .catch(e => e);
    },
    load() {
      return this.$store
        .dispatch("kelas/get", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            peran: this.peran,
            instruktur_id: this.instruktur
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    course(val) {
      window.open(val.link_moodle, "_blank");
    },
    filter(data) {
      this.peran = data.peran;
      this.instruktur = data.instruktur;
      this.load();
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },

    unduh() {
      var token = this.$store.getters["user/token"];
      return this.$store
        .dispatch("diklat/unduhTSFasilAdmin", {
          instansi_id: this.instansi_id,
          diklat_id: this.$route.params.diklat_id,
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },

    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    approve(item) {
      this.$confirm(
        `Apakah Anda yakin akan mengesahkan kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
        <span>Anda tidak dapat mengubah mata pelajaran yang telah Anda pilih setelah data Anda sahkan</span>`
      )
        .then(() => this.$store.dispatch("kelas/syncModul", item))
        .then(() => {
          this.$info(this.diklatAktif.jenisdiklat.label_kelas+" " + item.nama + " berhasil disinkron");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    selfEnrol(item) {
      this.$confirm(
        `Anda akan diarahkan ke LMS ${this.diklatAktif.jenisdiklat.label_kelas}<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/selfEnrol", item))
        .then(res => window.open(res.data[0].url, "_blank"))
        .catch(e => e);
    },

    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/drop", item))
        .then(() => {
          this.$info(this.diklatAktif.jenisdiklat.label_kelas+" " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    toWA(val) {
      window.open(`https://wa.me/` + val, "_blank");
    },
    cekFasil(fasilitator) {
      const defFasil = [
        {
          name: "Tidak tersedia",
          telp: ""
        }
      ];
      var fasils = [];
      fasilitator.forEach(f => fasils.push(f));
      return fasils.length > 0 ? fasils : defFasil;
    }
  },
  watch: {
    diklat_id() {
      this.load();
    }
  }
};
</script>
